import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Stack from '@mui/material/Stack';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import BasicError from './BasicError';
import useIsMobile from '../hooks/useIsMobile';

import 'dayjs/locale/es';
import InputLabel from './InputLabel';
import { useThemeCustomStyles } from '../hooks/useThemeConfig';

export default function DateInput({ control, handleChange, showValidation }) {
  const small = useIsMobile();
  const styles = useThemeCustomStyles();
  const inputStyle = styles.DateInput(small);
  const { validation } = control;
  return (
  	<Stack spacing={1} sx={{ height: '100%' }} >
		<InputLabel title={control.title} />		
	    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
	      <DatePicker value={control.data} onChange={handleChange} format="DD-MM-YYYY"
		   	slotProps={{
				textField: {
				  sx: inputStyle,
				  onBlur: (event) => {
					console.log('Input blurred. Value:', event.target.value);
				  }
				}
			  }}
			/>
	    </LocalizationProvider>
	    {showValidation && !validation.valid && (<BasicError error={validation.text} />)}
	</Stack>
  );
}